import React, { useState, useEffect, useRef, useCallback } from 'react'
import { useParams, useLocation } from 'react-router-dom'
import JoinPreview from '../components/_datasets/joinModule/JoinPreview'
import Paper from '@mui/material/Paper'
import Grid from '@mui/material/Grid'
import FormControl from '@mui/material/FormControl';
import Controls from "../components/controls/Controls";
import { makeStyles } from "@mui/styles";


import FunctionsOutlinedIcon from '@mui/icons-material/FunctionsOutlined';
import { Icon } from '@iconify/react';
import hashFill from '@iconify/icons-eva/hash-fill';
import DateRangeIcon from '@mui/icons-material/DateRange';
import LabelOutlinedIcon from '@mui/icons-material/LabelOutlined';


// material
import {
  Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Tab, List, ListItemIcon, ListItem, ListItemText, Menu, Accordion, AccordionSummary,
  AccordionDetails, Typography, Button, Box, Select, InputLabel, MenuItem, TextField, InputAdornment, Fade, DialogContent, DialogActions, Stack, Modal
} from '@mui/material';
import Popup from '../components/Popup';
import JoinConfig from '../components/_datasets/joinModule/JoinConfig'
import Loader from './Loader'
import { getDatasets, addJoinDataSetNew, updateDataSetJoinNew } from '../config/services/datasets'
import { useNavigate } from 'react-router-dom';

import toast from 'react-hot-toast'
import { ReactComponent as MoreIcon } from "../assets/icons/icon-more.svg";
import { ReactComponent as SearchIcon } from "../assets/icons/icon_search.svg"
import { ReactComponent as StringIcon } from "../assets/icons/icon_string.svg"
import { ReactComponent as DropDownIcon } from "../assets/icons/icon-angle-down.svg"
import { debouncingFn } from '../utils/Reusables'

const useStyles = makeStyles((theme) => ({
  grow: {
    flexGrow: 1,
  },
  title: {
    color: "#202124",
    fontSize: "22px",
  },
  subtitle: {
    fontSize: "14px",
    color: "#202124",
  },
  inputRoot: {
    color: "inherit",
  },
  inputInput: {
    padding: theme.spacing(1, 1, 1, 0),
    // vertical padding + font size from searchIcon
    paddingLeft: `calc(1em + ${theme.spacing(4)}px)`,
    transition: theme.transitions.create("width"),
    width: "100%",
    [theme.breakpoints.up("md")]: {
      width: "20ch",
    },
  },
  headingButton: {
    display: "block",
    width: "100%",
  },
  headingIcon: {
    display: "flex",
    "&:hover": {
      background: "none",
    },
  },
  reportHeader: {
    background: "transparent",
    boxShadow: "none",
    // borderBottom: '1px solid #DEDEDE',
  },
  button: {
    color: "#202124",
    fontWeight: 'normal',
    "&:hover": {
      background: "none",
    },
  },
  menuDropdownItem: {
    fontSize: '14px',
    color: '#202124',
    '&:hover': {
      backgroundColor: '#f6f6f6'
    }
  },
  searchFieldListItem: {
    paddingTop: '0.6rem',
    paddingBottom: '0.6rem',
    '&:hover': {
      background: "#f1f1f1",
      zIndex: 9,
      "& $listItemDescription": {
        visibility: 'visible'
      },
      "& $searchFieldListMoreIcon": {
        visibility: 'visible'
      }
    },
  },
  headingButtonWrap: {
    width: '90%',
    float: 'right',
    padding: '0 1rem',
    '&:hover': {
      backgroundColor: '#f45e29',
    },
    ['@media (max-width:1700px)']: {
      padding: '0 0.5rem',
      width: '95%',
      lineHeight: '16px',
      textAlign: 'center',
    },
    ['@media (max-width:1400px)']: {
      padding: '0.2rem 0.5rem',
      width: '95%',
      textAlign: 'center',
      lineHeight: '16px',
    },
    ['@media (max-width: 1199px)']: {
      float: 'left',
    }
  },
}));

function JoinModule() {
  const classes = useStyles();
  const navigate = useNavigate()
  const urlParams = useParams();
  const xPos = useRef(0)
  const { id } = urlParams;
  let { state } = useLocation();
  const dataSourceKey = state?.dataSource?._id
  const [datasetList, setDatasetList] = useState([])
  const [displayName, setDisplayName] = useState(null)
  const [datasetName, setDatasetName] = useState('')
  const [datasetDescription, setDatasetDescription] = useState('')
  const [addMenuEl, setAddMenuEl] = React.useState(null);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const openAddMenu = Boolean(addMenuEl);
  const [loader, setLoader] = useState(false)
  const [datasetLoader, setDatasetLoader] = useState(false);
  const [openPopup, setOpenPopup] = useState(false)
  const [measuresList, setMeasureList] = useState([])
  const [datasetSelectValue, setdatasetSelectValue] = useState({});
  const [joinDatasets, setJoinDatasets] = useState([])
  const [dataSetSearch, setDataSetSearch] = useState('')
  const [fieldListType, setFieldListType] = useState('all')
  const [selectedMeasure, setSelectedMeasure] = useState(null)
  const [editMeasureObj, setEditMeasureObj] = useState(null)
  const [currentDataset, setCurrentDataset] = useState({ ...state })
  const [selectedDatasetId, setSelectedDatasetId] = useState('')
  const [searchMeasure, setSearchMeasure] = useState('')
  const [filterMeasureList, setFilterMeasureList] = useState([])
  const [actualDataset, setActualDataset] = useState(null)
  const [joinConfig,setJoinConfig] = useState(null)
  const [clickedEdge,setClickedEdge] = useState(null)
  const [currentTarget,setCurrentTarget] = useState(null)

  const handleAddMenuHover = (event) => {
    //console.log(event,addMenuEl)
    if (addMenuEl != event.currentTarget) {
      setAddMenuEl(event.currentTarget);
    }
  };

  const handleAddMenuClose = () => {
    setAddMenuEl(null);
  };

  const cancelAddDataset = () => {
    //console.log('Cancel Clicked')
    setDataSetSearch('')
    setdatasetSelectValue(null)
    setOpenPopup(false)
  }

  const handleDatasetDescription = (e) => {
    //console.log(e)
    setDatasetDescription(e?.target?.value)
  }

  const openDataSetPopUp = () => {
    //const datasets = datasetList.filter(data => joinDatasets.every(join => join?._id !== data?._id));
    const newdataset = datasetList.filter(data => data?.dataSource?._id === dataSourceKey)
    setDatasetList(newdataset);
    setOpenPopup(true)
  }

  const handleDatasetSelect = (value) => {
    setdatasetSelectValue(value);    
  };

  const handlePopupDatasetSearch = (e) => {
    //console.log(e)
    let { value } = e.target
    setDataSetSearch(value)
  }

  const onChangeDatasetName = (e) => {
    setDisplayName(e?.target?.value);
    setDatasetName(e?.target?.value);
  }

  const handleSearchField = (e) => {
    setSearchMeasure(e?.target?.value)
  }

  const handleDimensionsNew = () => {
    let datasets = joinDatasets.filter(obj => obj.type == 'CustomNode')
    let currentNodeArr = datasets.map(obj => obj.id)
    let nodeArr = actualDataset.joinConfig ? Object.keys(actualDataset.joinConfig):[]
    let deletedNode = nodeArr.filter(obj => !currentNodeArr.includes(obj))
    if(deletedNode.length > 0){
      for(let key of deletedNode){
        delete actualDataset.joinConfig[key]
      }
    }
    
    let uniqueArr = [...new Map(datasets.map(item =>[item['dataSetName'], item])).values()];
    let primaryDimensions = uniqueArr.find( obj => obj._id == actualDataset.nodeId).dimensions
    nodeArr = actualDataset.joinConfig ? Object.keys(actualDataset.joinConfig):[]
    let dimensions = primaryDimensions.filter(obj => !obj.calculatedField).map(obj => {
      let newObj = {
        name: obj.name,
        type: obj.type,
        displayName: obj.displayName ?? obj.name,
        sql: obj.sql,
        dataType: obj.dataType,
        description: obj.description ?? '',
        dataSetType: obj.dataSetType
      }
      return newObj
    })
    let commonObj = {}
    for(let key of nodeArr) {
      let config = actualDataset.joinConfig[key]
      let primaryDataset = datasetList.find(obj => obj._id == config.primary.dataSetId)
      let secondaryDataset = datasetList.find(obj => obj._id == config.secondary.dataSetId)
      let secondaryDimensions = secondaryDataset.dimensions.filter(obj => !obj.calculatedField).map(obj => {
        let newObj = {
          name: obj.name,
          type: obj.type,
          displayName: obj.displayName ?? obj.name,
          sql: obj.sql,
          description: obj.description ?? '',
          dataType: obj.dataType,
          dataSetType: obj.dataSetType
        }
        return newObj
      })       
      let primaryDims = primaryDataset.dimensions.filter(obj => !obj.calculatedField).map(obj => {
        let newObj = {
          name: obj.name,
          type: obj.type,
          displayName: obj.displayName ?? obj.name,
          sql: obj.sql,
          description: obj.description ?? '',
          dataType: obj.dataType,
          dataSetType: obj.dataSetType
        }
        return newObj
      })
      let commonDimensions = primaryDims.filter(obj => secondaryDimensions.map(obj => obj.name).includes(obj.name)).map(obj => {
        let newObj = {
          name: obj.name,
          type: obj.type,
          displayName: obj.displayName ?? obj.name,
          sql: obj.sql,
          description: obj.description ?? '',
          dataType: obj.dataType,
          dataSetType: obj.dataSetType
        }
        return newObj
      }) 
      dimensions = dimensions.filter(obj => !commonDimensions.map(obj => obj.name).includes(obj.name))
      config.commonDimensions = commonDimensions
      //console.log(config)
    }
    //console.log(actualDataset.joinConfig)
  }

  const handleDimensions = () => {
    //console.log('Handle Dimensions')
    let datasets = joinDatasets.filter(obj => obj.type == 'CustomNode')
    let nodeArr = actualDataset.joinConfig ? Object.keys(actualDataset.joinConfig):[]
    let currentNodeArr = datasets.map(obj => obj.id)
    let deletedNode = nodeArr.filter(obj => !currentNodeArr.includes(obj))
    //console.log(deletedNode)
    if(deletedNode.length > 0){
      for(let key of deletedNode){
        delete actualDataset.joinConfig[key]
      }
    }
    //let dims = datasets.map(obj => obj.dimensions.filter(dim => !dim.calculatedField))
    //console.log(dims)
    let uniqueArr = [...new Map(datasets.map(item =>[item['dataSetName'], item])).values()];
    let primaryDimensions = uniqueArr.find( obj => obj._id == actualDataset.nodeId).dimensions
    uniqueArr = uniqueArr.filter(obj => obj._id != actualDataset.nodeId)
    let dimensions = primaryDimensions.filter(obj => !obj.calculatedField).map(obj => {
      let modObj = {
        type:obj.type,
        sql:obj.sql,
        name:obj.name,
        fieldName:obj.name,
        dataType:obj.dataType,
        dataSetId:actualDataset.nodeId,
        description: obj.description ?? '',
        dataSetType:obj.dataSetType        
      }
      return modObj
    })
    //console.log('Primary',primaryDimensions)
    for(let secondaryDataset of uniqueArr){
      let secondaryDimensions = secondaryDataset.dimensions.filter(obj => !obj.calculatedField).map(obj => {
        let modObj = {
          type:obj.type,
          sql:obj.sql,
          name:obj.name,
          fieldName:obj.name,
          dataType:obj.dataType,
          dataSetId:secondaryDataset._id,
          description: obj.description ?? '',
          dataSetType:obj.dataSetType
        }
        return modObj
      })  
      //console.log('Secondary',secondaryDimensions) 
      let commonDimensions = dimensions.filter(obj => secondaryDimensions.map(obj => obj.name).includes(obj.name)).map(obj => {
        let modObj = {
          type:obj.type,
          sql:obj.sql,
          actualSql:obj?.actualSql,
          name:obj.name,
          dataType:obj.dataType,
          dataSetId:obj.dataSetId,
          description: obj.description ?? '',
          dataSetType:obj.dataSetType
        }
        return modObj
      })      
      secondaryDimensions = secondaryDimensions.filter(obj => !commonDimensions.map(obj => obj.name).includes(obj.name))
      //console.log(commonDimensions,secondaryDimensions)
      let primarydim = commonDimensions.map(obj => {
        let sql = obj.actualSql && obj.actualSql.split(`.`).length > 1 ? obj.actualSql.split(`.`)[1]:obj.sql
        let dimension = primaryDimensions.find(dim => dim.name == obj.name)
        //console.log(dimension)
        if(dimension){
          let modObj = {
            name:obj.name,
            //sql:`${actualDataset.primaryDataset}.${sql}`,
            sql:`${actualDataset.primaryDataset.charAt(0).toLowerCase()}${actualDataset.primaryDataset.slice(1)}_${sql}`,
            actualSql:`${actualDataset.primaryDataset}.${sql}`,
            dataType:obj.dataType,
            dataSetId:obj.dataSetId,
            dataSetType:obj.dataSetType,
            description: obj.description ?? '',
            type:obj.type
          }
          return modObj
        }else{
          let dimension = dimensions.find(dim => dim.name == obj.name)
          if(dimension){
             let dataset = joinDatasets.find(dataObj => dataObj._id == dimension.dataSetId)
             //console.log(dataset,dimension)
            return {
              name:obj.name,
              //sql:`${actualDataset.primaryDataset}.${sql}`,
              sql:`${dataset.dataSetName.charAt(0).toLowerCase()}${dataset.dataSetName.slice(1)}_${sql}`,
              actualSql:`${dataset.dataSetName}.${sql}`,
              dataType:obj.dataType,
              dataSetId:obj.dataSetId,
              dataSetType:obj.dataSetType,
              description: obj.description ?? '',
              type:obj.type
            }
          }else{
            return ''
          }
        }        
      }).filter(String)
      dimensions = dimensions.filter(obj => !commonDimensions.map(obj => obj.name).includes(obj.name))
      let secondaryDim = commonDimensions.map(obj => {
        let name = `${obj.name.toLowerCase()}${secondaryDataset.dataSetName.toLowerCase()}`
        let sql = obj.actualSql && obj.actualSql.split(`.`).length > 1 ? obj.actualSql.split(`.`)[1]:obj.sql
        let modObj = {
          name:`${name.charAt(0).toUpperCase()}${name.slice(1)}`,
          sql:`${secondaryDataset.dataSetName.charAt(0).toLowerCase()}${secondaryDataset.dataSetName.slice(1)}_${sql}`,
          actualSql:`${secondaryDataset.dataSetName}.${sql}`,
          dataType:obj.dataType,
          dataSetType:obj.dataSetType,
          type:obj.type,
          dataSetId:obj.dataSetId,
          description: obj.description ?? '',
          displayName:obj.displayName ? obj.displayName : `${obj.name} (${secondaryDataset.dataSetName})`
        }
        return modObj
      })
      //console.log('Primary Common',primarydim)
      //console.log('Secondary Common',secondaryDim)
      dimensions = [...dimensions,...primarydim,...secondaryDim,...secondaryDimensions]
    }
    dimensions = dimensions.map(obj => {
      let actualDim = actualDataset.dimensions.find(dimObj => dimObj.name == obj.name || dimObj.sql == obj.sql)
      obj.joinHiddenField = actualDim ? (actualDim.joinHiddenField ?? false): false
      obj.displayName = actualDim ? (actualDim.displayName ?? actualDim.name): (obj.displayName ?? obj.name)
      obj.description = actualDim ? (actualDim.description ?? ""): (obj.description ?? "")
      return obj
    })
    //console.log('Dim',dimensions)
    if(state.mode == 'edit'){
      let actualDim = actualDataset.dimensions.filter(obj => obj.calculatedField && !obj.isHidden)
      //console.log(state)
      dimensions = [...dimensions,...actualDim]
    }
    //console.log([...new Map(dimensions.map(item =>[item['name'], item])).values()])
    let Dims = [...new Map(dimensions.map(item =>[item['name'], item])).values()].sort((a,b) => a.type.localeCompare(b.type) || ((a?.displayName && b?.displayName) ? (a.displayName.localeCompare(b.displayName)) : a.name.localeCompare(b.name)))
    //console.log(Dims)
    let datasetObj = {...actualDataset,dimensions:[...Dims.map(obj => {return {...obj}})]}
    //console.log('Handle Dimension')
    setActualDataset(datasetObj)
  }

  const fetchDatasetsList = () => {
    //console.log('Fetch Dataset List')
    setDatasetLoader(true)
    let params = { search: dataSetSearch,sortKey: 'dataSetName', dataSourceKey: dataSourceKey, sortOrder: '1',joinFlag:true }
    getDatasets(params)
      .then((res) => {
        setDatasetLoader(false)
        setDatasetList(res?.result); 
        let list = res?.result
        let dataset = { }
        if(!actualDataset){
          if(state.mode == 'add'){
            dataset = {
              sql: state.sql,
              dataSetName: '',
              datasetDescription:'',
              primaryTable: state.tableName,
              primaryDataset:state.dataSetName,
              position: state.position,
              nodeId: state.id,
              dimensions:state.dimensions,
              dataSource:state.dataSource,
              joinConfig: {
        
              }
            }      
          }else{      
            if(state.joinDatasetsProps){
              dataset = formatOldJoin(list)   
            }else if(state.nodeId){
              dataset = {...state}        
            }else{
              state.mode = 'add'
              dataset = state
              dataset.tableType = 'primary';
              dataset.id = dataset?._id;
              dataset.type = 'CustomNode'
              dataset.position = { x: 0, y: 0 };
              dataset.connectable = false
              dataset.nodeId = dataset.id
              dataset.data = { label: dataset?.dataSetName, _id: dataset.id, id: dataset.id }
            }
            //console.log(dataset)
            setDatasetName(dataset.displayName)
            setDatasetDescription(dataset?.datasetDescription ?? '')                     
          } 
          setActualDataset({...dataset})
        }        
      });
  }

  const createJoinDatasets = (joinConfig) => {
    let datasetObj = {}
    let joinConfigArr = Object.keys(joinConfig)
    let primaryDataset = datasetList.find(obj => obj._id == actualDataset.nodeId)
    ///console.log(actualDataset,datasetList,primaryDataset)
    actualDataset.primaryDataset = primaryDataset.dataSetName
    if(joinConfigArr.length > 0){
      //console.log(joinConfigArr)
      for(let key of joinConfigArr){
        //console.log(joinConfig[key])
        let dataset = datasetList.find(obj => obj._id == joinConfig[key].primary.dataSetId)
        //console.log(dataset)
        if(dataset){
          joinConfig[key].primary.dataSetName = dataset.dataSetName
          let position = dataset._id == actualDataset.nodeId ? actualDataset.position:joinConfig[key].position
          datasetObj[joinConfig[key].primary.dataSetId] = {            
            position:position ?? {x:0,y:actualDataset.position.y + 250},
            data:{
              label:dataset.displayName,
              _id:joinConfig[key].primary.nodeId,
              id:joinConfig[key].primary.nodeId
            },
            id:joinConfig[key].primary.nodeId,
            type:"CustomNode",
            ...dataset,
          }
        }
        dataset = datasetList.find(obj => obj._id == joinConfig[key].secondary.dataSetId)
        if(dataset){
          joinConfig[key].secondary.dataSetName = dataset.dataSetName
          let position = dataset._id == actualDataset.nodeId ? actualDataset.position:joinConfig[key].position
          datasetObj[joinConfig[key].secondary.dataSetId] = {...dataset,position:position ?? {x:0,y:actualDataset.position.y + 250},label:dataset.displayName,data:{label:dataset.displayName,_id:dataset._id,id:joinConfig[key].secondary.nodeId},id:joinConfig[key].secondary.nodeId,type:"CustomNode"}
        }
        let edge = {}
        edge.id = `edge-${joinConfig[key].secondary.nodeId}`
        edge.source = joinConfig[key].primary.nodeId
        edge.target = joinConfig[key].secondary.nodeId
        edge.type = 'buttonedge'
        datasetObj[edge.id] = edge
      }
      //console.log(datasetObj)
      let nodeArr = Object.values(datasetObj)
      setJoinDatasets([...nodeArr])
    }    
  }

  const handleFieldListType = (e) => {
    const type = e?.target?.value;
    //console.log(type)
    setFieldListType(type)
    //let list = type == 'all' ? actualDataset.dimensions.filter(obj => !obj.joinHiddenField):actualDataset.dimensions.filter(obj => obj.joinHiddenField)
    //setMeasureList([...list])
  }

  const prepareJoinDataSet = () => {
    //console.log('Dataset',actualDataset)
    if(datasetName){
      actualDataset.dataSetName = datasetName
      actualDataset.displayName = displayName
      actualDataset.datasetDescription = datasetDescription
      actualDataset.sql = generateSqlString()
      actualDataset['refreshKey'] = 'realTime'
      actualDataset['refreshKeyField'] = '24 hour'
      /* let dateFields = actualDataset.dimensions.filter(obj => obj.type == 'time')
      if (dateFields.length > 0) {
          if (dateFields.map(obj => obj.name).indexOf('updatedAt') > -1) {
            actualDataset['refreshKeyField'] = 'updatedAt'
          } else if (dateFields.map(obj => obj.name).indexOf('createdAt') > -1) {
            actualDataset['refreshKeyField'] = 'createdAt'
          } else if (dateFields.map(obj => obj.name).indexOf('timestamp') > -1) {
            actualDataset['refreshKeyField'] = 'timestamp'
          } else if (dateFields.map(obj => obj.name).indexOf('syncDate') > -1) {
            actualDataset['refreshKeyField'] = 'syncDate'
          } else {
            actualDataset['refreshKeyField'] = dateFields[0].name
          }
      } */
      //return false
      setLoader(true)
      //return false
      if(state.mode == 'add'){
        addJoinDataSetNew(actualDataset)
        .then(
          res => {
            setLoader(false)
            //console.log(res)
            if(res.result){
              toast.success('Dataset Added Successfully')
              navigate('/datasets')
            }else{
              let msg = res?.data?.error?.errorMessage
              toast.error(msg ?? 'Something went wrong, Please Contact Administrator')
            }           
          }
        ) 
        .catch(
          err => {
            setLoader(false)
            toast.error(err?.message ?? 'Something went wrong, Please try after sometime')
          }
        )
      }else{        
        actualDataset.dataSetId = state._id
        actualDataset.dataSetName = state.dataSetName
        if(state.joinDatasetsProps){
          actualDataset.oldDataset = true
        }
        updateDataSetJoinNew(actualDataset)
        .then(
          res => {
            setLoader(false)
            if(res.result){
              toast.success('Dataset updated Successfully')
              navigate('/datasets')
            }else{
              let msg = res?.data?.error?.errorMessage
              toast.error(msg ?? 'Something went wrong, Please Contact Administrator')
            } 
          }
        )
        .catch(
          err => {
            setLoader(false)
            toast.error(err?.message ?? 'Something went wrong, Please try after sometime')
          }
        )
      }
       
    }else{
      toast.error('Dataset Name is required')
      //console.log()
    }
  }

  const handleClick = (event, measure) => {
    //console.log('Measure',measure)
    event.stopPropagation()
    setAnchorEl(event.currentTarget)
    setSelectedMeasure(measure)
  }

  const handleClose = () => {
    setAnchorEl(null);
    setSelectedMeasure(null)
  };

  const editMeasureDescription = (type) => {
    //console.log('Edit Measure Description')
    switch (type) {
      case 'open':
        setEditMeasureObj({ openPopup: true })
        setAnchorEl(null)
        break
      case 'cancel':
        setEditMeasureObj({ openPopup: false })
        setSelectedMeasure(null)
        break
      case 'submit':
        //console.log(selectedMeasure)
        actualDataset.dimensions = actualDataset.dimensions.map(
          obj =>{ 
            if(obj.name == selectedMeasure.name && obj.sql == selectedMeasure.sql){
              obj.displayName = selectedMeasure.displayName
              obj.description = selectedMeasure.description ?? ""
            }
            return obj
          }
        )
        setActualDataset({...actualDataset})
        setMeasureList([...actualDataset.dimensions])
        setEditMeasureObj({ openPopup: false })
        handleClose()
        break
    }
  }

  const handleFieldDetails = (e) => {
    let { name, value } = e.target
    let newMeasureObject = { ...selectedMeasure, [name]: value }
    setSelectedMeasure(newMeasureObject)
  }

  const handleFieldHide = (e) => {
    //console.log(selectedMeasure)
    //console.log('Handle Field Hide')
    actualDataset.dimensions = actualDataset.dimensions.map(
      obj =>{ 
        if(obj.name == selectedMeasure.name && obj.sql == selectedMeasure.sql){
          obj.joinHiddenField = true
        }
        return obj
      }
    )
    setActualDataset({...actualDataset})
    setMeasureList([...actualDataset.dimensions])
    handleClose()
  }

  const handleUnhideFeild = () => {
    //console.log('Handle Field Unhide')
    actualDataset.dimensions = actualDataset.dimensions.map(
      obj =>{ 
        if(obj.name == selectedMeasure.name && obj.sql == selectedMeasure.sql){
          obj.joinHiddenField = false
        }
        return obj
      }
    )
    setActualDataset({...actualDataset})
    setMeasureList([...actualDataset.dimensions])
    handleClose()
  }

  const selectJoinDataSet = () => {
    setDataSetSearch('')
    //console.log('Select Join dataset',datasetSelectValue)
    let dataset = datasetList.find(obj => obj._id == datasetSelectValue)
    //console.log(dataset)
    if (dataset) {
      //let sourceDataset = joinDatasets.find(obj => obj._id == currentDataset.id)
      let selected = { ...dataset }
      const targetRandomId = `${currentDataset.id}-${selected?._id}`
      selected.tableType = 'secondary';
      xPos.current += 250
      selected.id = targetRandomId;
      selected.data = { label: selected?.displayName || selected?.dataSetName, _id: selected._id, id: targetRandomId }
      selected.type = 'CustomNode'
      selected.connectable = false
      selected.position = { x: currentDataset.position.x, y: currentDataset.position.y + 250 };
      //const targetId = targetRandomId
      let edge = {}
      edge.id = `edge-${currentDataset.id}-${targetRandomId}`
      edge.source = currentDataset?.id
      edge.target = targetRandomId
      edge.type = 'buttonedge'
      actualDataset.joinConfig = {
        ...actualDataset.joinConfig,
        [selected.id]: {
          primary: {
            nodeId: currentDataset.id,
            dataSetId: currentDataset._id,
            tableName: currentDataset.tableName,
            dataSetName: currentDataset.dataSetName,
          },
          secondary: {
            nodeId: selected.id,
            dataSetId: selected._id,
            tableName: selected.tableName,
            dataSetName: selected.dataSetName,
          },
          joinType:'LEFT',
          joinCondition: [

          ],
          position: selected.position
        }
      }
      setActualDataset({ ...actualDataset })
      setdatasetSelectValue(null)
      joinDatasets.push(selected)
      joinDatasets.push(edge)
      setJoinDatasets([...joinDatasets])
      setOpenPopup(false)
    }
  }

  const edgeClickHandler = (evt, id) => {
    setClickedEdge(id)    
  }

  const configCloseHandler = () => {
    setJoinConfig(null)
    setCurrentTarget(null)
    setClickedEdge(null)
  }

  const handleApplyJoin = (joinConfig) => {
    //console.log('Handle Apply Join')
    let invalid = false
    for(let key of Object.keys(actualDataset.joinConfig)){
      if(!invalid && actualDataset.joinConfig[key].joinCondition.length > 0){
        let index = 0;
        for(let condition of actualDataset.joinConfig[key].joinCondition){       
          if(condition.secondaryFieldName == '' || condition.primaryFieldName == ''){
            invalid = true
            break;
          }
        }
      }else{
        invalid = true
        break;
      }      
    }
    if(invalid){
      toast.error('Please provide join clause for all datasets')
    }else{
      handleDimensions()
      delete joinConfig.dimensions
      actualDataset.joinConfig[currentTarget] = joinConfig
      setActualDataset({...actualDataset})    
      setCurrentTarget(null)
      setJoinConfig(null)
      setClickedEdge(null)
    }    
  }

  const generateSqlString = () => {
    //console.log(actualDataset.dimensions)
    //return false
    let fields = actualDataset.dimensions.filter(obj => !obj.calculatedField).map(obj => {
      if(obj.actualSql){
        return `${obj.actualSql} AS ${obj.sql}`
      }else{
        return obj.sql
      }      
    }).join(', ')
    let sql = `SELECT ${fields} FROM ${actualDataset.dataSource.dbName}.${actualDataset.primaryTable} AS ${actualDataset.primaryDataset}`
    for(let key of Object.keys(actualDataset.joinConfig)){
      let index = 0;
      sql = `${sql} ${actualDataset.joinConfig[key].joinType} JOIN ${actualDataset.dataSource.dbName}.${actualDataset.joinConfig[key].secondary.tableName} AS ${actualDataset.joinConfig[key].secondary.dataSetName} ON`
      for(let condition of actualDataset.joinConfig[key].joinCondition){
        if(index > 0){
          if(condition.type == 'dynamic'){
            sql = `${sql} AND ${condition.primaryFieldName} = ${condition.secondaryFieldName}`
          }else{
            switch(condition.primaryFieldType){
              case 'number':
                sql = `${sql} AND ${condition.primaryFieldName} = ${parseFloat(condition.secondaryFieldName)}`
                break;
              default:
                sql = `${sql} AND ${condition.primaryFieldName} = '${condition.secondaryFieldName}'`
                break;
            }                
          }              
        }else{
          if(condition.type == 'dynamic'){
            sql = `${sql} ${condition.primaryFieldName} = ${condition.secondaryFieldName}`
          }else{
            switch(condition.primaryFieldType){
              case 'number':
                sql = `${sql} ${condition.primaryFieldName} = ${parseFloat(condition.secondaryFieldName)}`
                break;
              default:
                sql = `${sql} ${condition.primaryFieldName} = '${condition.secondaryFieldName}'`
                break;
            }                
          }
        }
        index++
      }
    }
    sql = `${sql} WHERE [SECURITY_CONTEXT]`
    return sql
  }

  const formatOldJoin = (dataSetList) => {
    let allDatasets = Object.values(state.joinDatasetsProps)
    let joinConfigArr = Object.values(state.joinConfig)
    let primaryDataset = allDatasets.find(obj => obj.tableType == 'primary')
    let primaryTable = dataSetList.find(obj => obj._id == primaryDataset.id)
    let datasetNew = {
      sql: state.sql,
      dataSetName: state.dataSetName,
      datasetDescription:state.datasetDescription,
      displayName:state.displayName,
      primaryTable: primaryTable.tableName,
      primaryDataset:primaryTable.dataSetName,
      position: primaryDataset.position,
      nodeId: primaryTable._id,
      dimensions:state.dimensions,
      dataSource:state.dataSource,
      joinConfig: {

      }
    }
    state.nodeId = primaryDataset.id
    //console.log(joinConfigArr,state)
    //let joinDatasets = []
    for(let obj of joinConfigArr){
      if(obj.primaryDataset && obj.primaryDataSetKey){
        let primaryObj = dataSetList.find(elem => elem._id == obj.primaryDataset)
        let secondaryObj = dataSetList.find(elem => elem._id == obj.secondaryDataset)
        datasetNew.joinConfig[obj.secondaryDataSetKey] = {
          primary:{
            nodeId:obj.primaryDataSetKey,
            dataSetId:obj.primaryDataset,
            tableName:primaryObj.tableName,
            dataSetName:primaryObj.dataSetName
          },
          secondary:{
            nodeId:obj.secondaryDataSetKey,
            dataSetId:obj.secondaryDataset,
            tableName:secondaryObj.tableName,
            dataSetName:secondaryObj.dataSetName
          },
          joinType:obj.joinType.toUpperCase(),
          joinCondition:[

          ],
          position:state.joinDatasetsProps[obj.secondaryDataSetKey].position
        }
        for(let condition of obj.clause){
          datasetNew.joinConfig[obj.secondaryDataSetKey].joinCondition.push({
            type:'dynamic',
            primaryFieldName:`${primaryObj.dataSetName}.${condition[obj.primaryDataset]}`,
            primaryDataset:obj.primaryDataset,
            secondaryDataset:obj.secondaryDataset,
            secondaryFieldName:`${secondaryObj.dataSetName}.${condition[obj.secondaryDataset]}`,
            primaryFieldType:`string`
          })
        }
      }      
    }
    return datasetNew
  }

  useEffect(debouncingFn(fetchDatasetsList), [dataSetSearch]);

  useEffect(() => {
    if(actualDataset){
      let measures = []
      if(searchMeasure){
        measures = actualDataset.dimensions.filter(obj => obj.name.toLowerCase().includes(searchMeasure.toLowerCase()) || (obj.displayName && obj.displayName.toLowerCase().includes(searchMeasure.toLowerCase())))
      }else{
        measures = actualDataset.dimensions
      }
      setMeasureList(measures)
    }    
  },[searchMeasure])

  useEffect(() => {
    if(clickedEdge){
      let obj = joinDatasets.find(obj => obj.id == clickedEdge)
      //console.log(actualDataset.joinConfig[obj.target])
      if(actualDataset.joinConfig[obj.target].joinCondition.length < 1){
        actualDataset.joinConfig[obj.target].joinCondition = [
          {
            type:'dynamic',
            primaryFieldName:'',
            primaryDataset:actualDataset.joinConfig[obj.target].primary.dataSetId,
            secondaryDataset:actualDataset.joinConfig[obj.target].secondary.dataSetId,
            secondaryFieldName:''
          }
        ]
      }
      setJoinConfig(actualDataset.joinConfig[obj.target])
      setCurrentTarget(obj.target)
      //console.log(obj,actualDataset)
    }
  },[clickedEdge])

  useEffect(() => {
    //console.log('Join Dataset',joinDatasets,actualDataset)
    if (joinDatasets.length > 0 && actualDataset) {
      let datasets = joinDatasets.filter(obj => obj.type == 'CustomNode')
      for (let node of datasets) {
        if (actualDataset.nodeId == node.id) {
          actualDataset.position = node.position
        } else {
          actualDataset.joinConfig[node.id].position = node.position
        }
      }
      setActualDataset((prevState) => {return { ...actualDataset }})
      setCurrentTarget(null)
      setJoinConfig(null)
      setClickedEdge(null)
      handleDimensions()
    }
  }, [joinDatasets])  

  useEffect(() => {    
    if(actualDataset){
      //console.log('Actual Dataset', actualDataset)
      if(joinDatasets.length < 1 && state.mode == 'add'){      
        //console.log('Actual Dataset Add', {...actualDataset.dimensions})  
        let datasetArr = joinDatasets.length > 0 ? [...joinDatasets] : [{...state}]
        //console.log('Inside',joinDatasets,datasetArr)
        setJoinDatasets([...datasetArr])
      }   
      setMeasureList(actualDataset.dimensions)
      if(joinDatasets.length < 1){
        //console.log('Actual Dataset Length', {...actualDataset.dimensions})
        if(state.mode == 'edit'){
          //console.log('Actual Dataset Edit', {...actualDataset.dimensions})
          if(actualDataset.joinConfig){
            createJoinDatasets(actualDataset.joinConfig)
          }
        }
        setDatasetLoader(false)
      }
    }    
  }, [actualDataset])

  useEffect(() => {
    let dataset = joinDatasets.find(obj => obj.id == selectedDatasetId)
    setCurrentDataset(dataset)
  }, [selectedDatasetId])

  /* useEffect(() => {
    fetchDatasetsList()       
  }, []) */

  return (
    <Grid container className="join_module_wrapper datasets_module_wrapper">
      <Grid container mb={2} className="report-new-header-container" >
        <Grid container item alignItems="start" justifyContent="center" direction="column" mb={2}
          xs={12} sm={6} md={6} lg={6} order={{ lg: 1, md: 2, sm: 2, xs: 2 }} >
          <FormControl sx={{ marginBottom: '1rem' }}>
            <TextField placeholder="Dataset Name" size="small" variant="standard" value={displayName || datasetName} onChange={onChangeDatasetName}
              className="report-header-input main-title" />
          </FormControl>
          <FormControl fullWidth className={classes.margin}>
            <TextField placeholder="Add Description" size="small" variant="standard" value={datasetDescription} onChange={handleDatasetDescription}
              className="report-header-input" />
          </FormControl>
        </Grid>
        <Grid className="report-header-action-items datasets-header-action-items" container item mb={1.5} spacing={0} alignItems="center"
          xs={12} sm={6} md={6} lg={6} order={{ lg: 2, md: 2, sm: 2, xs: 1 }} >
          <Grid container item xs={12} sm={6} md={6} lg={6} alignItems="" >
            <Box >
              <Grid container display="flex">

              </Grid>
            </Box>
          </Grid>
          <Grid container item xs={12} sm={6} md={6} lg={6} justifyContent="flex-end">
            <Box  >
              <Grid container display="flex" alignItems="center" className="datasets-add">
                <Grid className="" item xs={6}  >
                  
                </Grid>
                <Grid className="" item xs={6} >
                  <Box className={classes.headingButton}>
                    <Controls.Button className={classes.headingButtonWrap + " report_form_ui_btn primary"} text="Save" variant="contained" component={""} to="" onClick={prepareJoinDataSet} />
                  </Box>
                </Grid>
              </Grid>
            </Box>
          </Grid>

        </Grid>
      </Grid>
      <Box sx={{ flexGrow: 1 }}>
        <Grid spacing={2} container className="Datasets-container">
          <Grid item md={4} sm={12}>
            <Box width="100%" height="100%" className="join-module-setting" >
              <Typography variant="h5" display="block" className="dataset-filter-title" > Fields </Typography>
              <FormControl fullWidth>
                <Typography className="dataset-input-label font-weight-normal" variant="button" display="block" sx={{ pb: '5px !important' }}  >All fields includes </Typography>
                <TextField className="cm_rprt_setting_content report_form_ui_input dataset-fields-input" type="search" size="small" placeholder="Search field"
                  onChange={handleSearchField}
                  autoComplete='off'
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="start">
                        <SearchIcon className="input_search_icon" />
                      </InputAdornment>
                    ),
                    classes: {
                      input: classes.formInput,
                      adornedEnd: classes.bgWhite + " form_input"
                    },
                    autoComplete: 'off'
                  }} />
              </FormControl >
              <FormControl fullWidth>
                <Typography className="report-form-label font-weight-normal" variant="subtitle1" display="block" mt={2} > Focus </Typography>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  className="cm_rprt_setting_content report_form_ui_input_select dataset_focus_input" size='small'
                  onChange={handleFieldListType}
                  IconComponent={DropDownIcon}
                  MenuProps={{
                    classes: {
                      root: `form-select-menu`,
                    },
                  }}
                  defaultValue={fieldListType}
                  value={fieldListType}
                >
                  <MenuItem className={classes.menuDropdownItem + " menu-item"} value="all">All fields</MenuItem>
                  {/*<MenuItem className={classes.menuDropdownItem + " menu-item"} value="calculated">Calculated Fields</MenuItem>*/}
                  <MenuItem className={classes.menuDropdownItem + " menu-item"} value="hidden">Hidden Fields</MenuItem>

                </Select>
                <Typography className="report-form-label report-form-select font-weight-normal" variant="button" display="block" mt={1}>Select <span>All</span>|<span>None</span></Typography>
              </FormControl>
              <div className="datasets_field_list" >
                <List component="nav">
                  {measuresList.length > 0 && measuresList.map((measure) => (
                    ( (fieldListType === 'hidden' && measure?.joinHiddenField) || (fieldListType === 'all' && !measure?.joinHiddenField)) &&
                    ( 
                      <ListItem className="datasets_listitem" key={measure.name}>
                        <ListItemIcon>
                          {measure.dataSetType === "MEASURE" ? <FunctionsOutlinedIcon className="cm_dimension_icon" /> : measure.type === "number" ? <Icon icon={hashFill} className="cm_measr_lbl num_icon" /> : measure.type === "time" ? <DateRangeIcon className="cm_measr_lbl" /> : <LabelOutlinedIcon className="cm_measr_lbl" />}
                        </ListItemIcon>
                        <ListItemText primary={measure.displayName ? measure.displayName : measure.name} />
                        <Button
                          id="basic-button"
                          className="menu-btn1 form_icon"
                          aria-controls="datasets-menu"
                          aria-haspopup="true"
                          aria-expanded={0 ? 'true' : undefined}
                          onClick={(e) => handleClick(e, measure)}>
                          <MoreIcon />
                        </Button>
                      </ListItem>
                    )))}
                    <Menu
                      id="simple-menu"
                      anchorEl={anchorEl}
                      keepMounted
                      open={Boolean(anchorEl)}
                      onClose={handleClose}
                      className={classes.fieldMenu}
                    >
                      <div>
                        <MenuItem className={classes.menuDropdownItem + " menu-item text-plain font-weight-500"}  onClick={(e) => editMeasureDescription('open')} > Edit Name/Description </MenuItem>
                        {
                          !selectedMeasure?.joinHiddenField &&
                          <MenuItem className={classes.menuDropdownItem + " menu-item text-plain font-weight-500"}  onClick={(e) => handleFieldHide(e)}  > Hide Field</MenuItem>
                          }
                        {
                          selectedMeasure?.joinHiddenField && (
                            <MenuItem className={classes.menuDropdownItem + " menu-item text-plain font-weight-500"}  onClick={handleUnhideFeild} > Unhide Field</MenuItem>
                          )
                        }
                      </div>
                    </Menu>
                </List>
              </div>
            </Box>
          </Grid>

          <Grid item md={8} sm={12}>
            <Box className="datasets-new-main-content-section">
              <Grid container sx={{ height: '100%' }} className="Datasets-container">
                <Grid item lg={12}>
                  {loader && <Loader />}
                </Grid>
                <Grid item lg={12} sm={12}>
                  <Grid item lg={12} sm={12} style={{ width: '100%', height: '500px' }}>
                    <Paper elevation={3} className="join_module_wrapper">
                      <JoinPreview
                        joinDatasets={joinDatasets}
                        setJoinDatasets={setJoinDatasets}
                        setSelectedDatasetId={setSelectedDatasetId}
                        openDataSetPopUp={openDataSetPopUp}
                        edgeClickHandler={edgeClickHandler}
                        setMeasureList={setMeasureList}
                        setFilterMeasureList={setFilterMeasureList}
                      />
                    </Paper>
                  </Grid>
                  <Grid item container lg={12} className="join_config">
                    <JoinConfig
                      joinDatasets={joinDatasets}
                      setJoinDatasets={setJoinDatasets}
                      datasetList={datasetList}
                      joinConfig={joinConfig}
                      handleApplyJoin={handleApplyJoin}
                      handleDimensions={handleDimensions}
                      configCloseHandler={configCloseHandler}
                    />
                  </Grid>
                </Grid>
              </Grid>
            </Box>
          </Grid>

        </Grid>
      </Box>

      {/* Add Dataset Popup */}
      <Popup title="Select Dataset " openPopup={openPopup} setOpenPopup={setOpenPopup}>
        <Grid item lg={12}> {datasetLoader && <Loader />} </Grid>
        <Grid container className="dataset-content">
          <FormControl fullWidth>
            <TextField className="cm_rprt_setting_content report_form_ui_input" type="search" size="small" placeholder="Search for dataset"
              onChange={handlePopupDatasetSearch}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon />
                  </InputAdornment>
                ),
              }}
            />
          </FormControl>
          <div className="datasets_field_list  add_datasets_list">
            <List buton="true">
              {datasetList.map((dataSet, i) => (
                <ListItem key={i} className={`datasets_listitem ${dataSet._id === datasetSelectValue ? 'opt_highlight' : null}`} onClick={() => handleDatasetSelect(dataSet?._id)}>
                  <ListItemIcon>
                    <StringIcon />
                  </ListItemIcon>
                  <ListItemText
                    primary={dataSet?.displayName || dataSet?.dataSetName}
                    secondary={dataSet?.description ?? 'No Description'}
                  />
                </ListItem>
              ))}
            </List>
          </div>
          <DialogActions className="btn-group">
            <Button color="primary" onClick={cancelAddDataset} className="report_form_ui_btn cancel mr-2">Back</Button>
            <Button color="error" onClick={selectJoinDataSet} autoFocus className="report_form_ui_btn submit">Select</Button>
          </DialogActions>
        </Grid>
      </Popup>

      {/* Edit Measure Popup */}
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        className="modal-root"
        open={editMeasureObj?.openPopup ?? false}
        onClose={() => {return false}}
        closeAfterTransition
      >
        <Fade in={editMeasureObj?.openPopup}>
          <Box className="modal-paper modal-box modal-md" id="transition-modal-title">
              <Box className="modal-header" >
                <Typography variant="subtitle1" className="modal-header-title" >{`Update Field`}</Typography>
              </Box>
            <Box className="modal-content">
              <Typography className="text-small label" variant="p">Field Name</Typography>
              <TextField name='displayName' onChange={handleFieldDetails} value={selectedMeasure?.displayName === undefined ? selectedMeasure?.name : selectedMeasure?.displayName} 
                className="report_form_ui_input width-100 mb-1" placeholder="" /> <br />
              
              <Typography className="text-small label" variant="p">Field Description</Typography>
              <TextField  name='description' onChange={handleFieldDetails} value={selectedMeasure?.description} className="report_form_ui_input width-100" 
                 placeholder="" />
              
              <Box className="modal-footer text-right">
                <Button onClick={() => editMeasureDescription('cancel')} color="error" className="report_form_ui_btn mr-2 cancel" variant="outlined" > Cancel </Button>
                <Button onClick={() => editMeasureDescription('submit')} color="primary" autoFocus className="report_form_ui_btn submit" variant="contained"> Save </Button>
              </Box>
            </Box>
            
          </Box>
        </Fade>
      </Modal>
    </Grid>

  )
}

export default JoinModule


